import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import {
  useMultihostService,
  RemoteNetworkQuality,
} from '@commentsold/multihost';
import { useUserStore } from '@/composables/useUserStore';

const remoteNetworkQualityPollingInterval = 5000;
const networkQualityLabelMap = {
  UNSTABLE: 'Unstable Connection',
  POOR: 'Poor Connection',
  GOOD: 'Good Connection',
} as const;
export const useNetworkQualityStore = defineStore(
  'mhcRemoteNetworkQuality',
  () => {
    const remoteUsersNetworkQuality = ref<RemoteNetworkQuality>({});
    const multihostService = useMultihostService();
    const { getRemoteUserNetworkQuality } = multihostService;
    const { networkUplinkQuality } = storeToRefs(multihostService);
    const localUserNetworkUplinkQuality = computed(
      () => networkUplinkQuality.value
    );
    const localNetworkQuality = computed(() => {
      let quality = 'UNSTABLE';
      if (
        ['UNKNOWN', 'DISCONNECTED', 'EXCELLENT', 'OK'].includes(
          networkUplinkQuality.value
        )
      ) {
        quality = 'GOOD';
      }
      if (networkUplinkQuality.value === 'POOR') {
        quality = 'POOR';
      }
      return quality as 'UNSTABLE' | 'GOOD' | 'POOR';
    });
    const isLocalUserNetworkUplinkQualityGood = computed(
      () => localNetworkQuality.value === 'GOOD'
    );
    const localUserNetworkUplinkQualityStatusText = computed(
      () => networkQualityLabelMap[localNetworkQuality.value]
    );

    const { user } = storeToRefs(useUserStore());
    const updateRemoteNetworkQuality = () => {
      if (user.value.type === 'director') {
        remoteUsersNetworkQuality.value = getRemoteUserNetworkQuality();
      }
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    window._simulatePoorNetwork = () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      for (const key in remoteUsersNetworkQuality.value) {
        remoteUsersNetworkQuality.value[key] = {
          uplinkNetworkQuality: 'POOR',
          downlinkNetworkQuality: 'POOR',
        };
      }
    };
    let remoteNetworkQualityPollID: ReturnType<typeof setInterval>;
    const pollRemoteNetworkQuality = () => {
      clearInterval(remoteNetworkQualityPollID);
      remoteNetworkQualityPollID = setInterval(
        updateRemoteNetworkQuality,
        remoteNetworkQualityPollingInterval
      );
    };

    return {
      localNetworkQuality,
      pollRemoteNetworkQuality,
      updateRemoteNetworkQuality,
      remoteUsersNetworkQuality,
      localUserNetworkUplinkQuality,
      isLocalUserNetworkUplinkQualityGood,
      localUserNetworkUplinkQualityStatusText,
    };
  }
);
